import { Check } from 'lucide-react';
import { SEG_META, SEG_ORDER } from '@/lib/segments';

/**
 * Sélecteur de familles de dons (Ensemble / Dons réguliers / Parrainage).
 *
 * Deux modes :
 *  • multi  (défaut) : cases à cocher — superposition/comparaison sur un graphe.
 *                      `value` = tableau de clés, `onChange(nouveauTableau)`.
 *                      Garantit au moins une famille sélectionnée.
 *  • single          : radio — scope une page/élément sur UNE famille.
 *                      `value` = clé unique, `onChange(cle)`.
 *
 * N'affiche rien tant que le parrainage n'est pas activé pour l'association.
 */
export function SegmentChips({
  value,
  onChange,
  single = false,
  enabled = true,
  options = SEG_ORDER,
  className = '',
  testid = 'segment-chips',
  label = 'Famille de don',
}) {
  if (!enabled) return null;

  const selected = single ? [value] : (value || []);
  const isActive = (k) => selected.includes(k);

  const handle = (k) => {
    if (single) { onChange(k); return; }
    const set = new Set(value || []);
    if (set.has(k)) { if (set.size > 1) set.delete(k); } // jamais vide
    else set.add(k);
    onChange(SEG_ORDER.filter((x) => set.has(x)));
  };

  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid={testid}
      role={single ? 'radiogroup' : 'group'} aria-label={label}>
      {options.map((k) => {
        const m = SEG_META[k];
        const active = isActive(k);
        return (
          <button
            key={k}
            type="button"
            onClick={() => handle(k)}
            data-testid={`${testid}-${k}`}
            role={single ? 'radio' : 'checkbox'}
            aria-checked={active}
            className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors duration-150 ${
              active ? 'border-transparent text-white shadow-sm' : 'bg-card text-muted-foreground hover:text-foreground hover:bg-muted/60'
            }`}
            style={active ? { background: m.color } : {}}
          >
            {active
              ? <Check className="h-3 w-3" strokeWidth={3} />
              : <span className="h-2 w-2 rounded-full" style={{ background: m.color }} />}
            {m.short}
          </button>
        );
      })}
    </div>
  );
}
